import { render } from "./Kbd.vue?vue&type=template&id=a94bdeb6&ts=true"
import script from "./Kbd.vue?vue&type=script&setup=true&lang=ts"
export * from "./Kbd.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/kbd/Kbd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a94bdeb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a94bdeb6', __exports__)) {
    api.reload('a94bdeb6', __exports__)
  }
  
  module.hot.accept("./Kbd.vue?vue&type=template&id=a94bdeb6&ts=true", () => {
    api.rerender('a94bdeb6', render)
  })

}


export default __exports__